module.exports = __webpack_public_path__ + "img/6X4.c708b83b.png";